/**
 * Spike — a static ground hazard (Brief 007 P2).
 *
 * Always hurts on contact; NEVER stompable (no top-check). The body sits on the
 * tile floor so the 64² sprite's base aligns with the ground surface.
 *
 * Determinism: no motion, no random, no transcendentals — ESLint-clean.
 */
import type { Entity, EntityContext } from '../Entity';
import { EntityType } from '../LevelFormat';
import type { AABB } from '../TileGrid';

export class Spike implements Entity {
  readonly type = EntityType.SPIKE;
  body: AABB;
  vx = 0;
  vy = 0;
  facing: 1 | -1 = 1;
  alive = true;
  /**
   * COMBAT: authored `props.pogoable` → a down-attack bounces off this spike instead of
   * the spike being a wall of death. The SAME geometry plays differently per archetype
   * (lethal in CLASSIC/PRECISION, a climbing surface in COMBAT). It still hurts on body
   * contact (onPlayerOverlap unchanged) — you bounce on TOP, you don't wade through it.
   * Default false → today's lethal spike, byte-identical.
   */
  readonly pogoable: boolean;

  /**
   * @param cx     spawn center-x (world px)
   * @param feetY  bottom of the entity's tile cell (world px) — body sits flush here
   * @param props  `pogoable` (COMBAT climbable-hazard flag); otherwise unused
   */
  constructor(cx: number, feetY: number, props?: Record<string, unknown>) {
    // Body is 56 wide × 40 tall, sitting on the tile floor.
    // The spike art is bottom-aligned in the 64² frame, so hitbox matches visuals.
    this.body = { x: cx - 28, y: feetY - 40, w: 56, h: 40 };
    this.pogoable = props?.pogoable === true;
  }

  update(_dt: number, _ctx: EntityContext): void { /* static — no movement */ }

  onPlayerOverlap(ctx: EntityContext): void {
    // ALWAYS hurt — spikes are not stompable under any condition.
    ctx.hurtPlayer();
  }

  spriteKey(): string { return 'spike'; }
  visible(): boolean { return true; }
}
